import th from 'element-ui/lib/locale/lang/th';

// 泰语(泰国)
export default {
  ...th,
  layout: {
    title: 'ลงชื่อเข้าใช้ด้วย Uniportal ID',
    tip: 'หมายเลขโทรศัพท์ที่ไม่ได้ลงทะเบียนจะลงทะเบียนโดยอัตโนมัติเมื่อเข้าสู่ระบบสําเร็จ',
    line: 'ตัวเลือกการล็อกอินอื่น ๆ',
  },
  button: {
    submit: 'เข้าสู่ระบบ/ลงทะเบียน',
    getCode: 'รับรหัส',
    emailRegister: 'ลงทะเบียนโดยอีเมล',
    w3Login: 'การล็อกอินบัญชี W3',
    employeeLogin: 'เข้าสู่ระบบพนักงาน',
    passwordLogin: 'ล็อกอินด้วยรหัสผ่าน',
    reSend: 'ส่งอีกครั้ง',
    problem: 'ความช่วยเหลือออนไลน์',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
  },
  placeholder: {
    phoneNumber: 'หมายเลขโทรศัพท์มือถือ',
    verificationCode: 'รหัสการยืนยันทาง SMS',
  },
  dialog: {
    imgCode: 'กรอกอักขระบนภาพ',
    userAgreements: {
      header: 'ข้อตกลงผู้ใช้และคำชี้แจงความเป็นส่วนตัว',
      text1: 'โปรดอ่านและยอมรับ {privacy} และ {agreement}',
      text2:
        'ข้อมูลส่วนบุคคลจะถูกส่งไปยังบริษัทในเครือในต่างประเทศของ Huawei เพื่อประมวลผลเมื่อเข้าถึงแอป Huawei ในต่างประเทศ ดูรายละเอียดได้ที่ {privacy}',
    },
    crossBorder: {
      header: 'การแจ้งเตือนการอนุญาต',
      text: 'บริการในพื้นที่ที่คุณใช้และการลงทะเบียนบัญชีของคุณไม่ได้อยู่ในภูมิภาคเดียวกัน คุณจะต้องได้รับการอนุญาตจากคุณเพื่อเข้าถึงข้อมูลบัญชีข้ามพรมแดน',
    },
    multiAccounts: 'เลือกบัญชี',
    agreeButton: 'ยอมรับและดำเนินการต่อ',
    disagreeButton: 'ไม่ยอมรับ',
    confirmButton: 'ยืนยัน',
    cancelButton: 'ยกเลิก',
    knowMe: 'ตกลง',
  },
  toast: {
    hasSend: 'ส่งรหัสการยืนยันแล้ว',
    wait: 'กรุณารอสักครู่',
  },
  tooltip: {
    Huawei: 'Huawei ID',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'ไม่สามารถเว้นว่างรหัสแคปต์ชาได้',
    'IDC-03-0002': 'รหัสแคปต์ชาหมดอายุแล้ว',
    'IDC-00-0004': 'รหัสแคปต์ชาไม่ถูกต้อง',

    // 表单输入为空
    'IDC-01-00024': 'ต้องการรหัสประเทศในการยืนยันหมายเลขโทรศัพท์มือถือของคุณ',
    phoneNumberEmpty: 'กรอกหมายเลขโทรศัพท์มือถือ',
    'IDC-03-00033': 'กรอกรหัสการยืนยันทาง SMS',

    // 表单数据错误
    'IDC-02-00227': 'หมายเลขโทรศัพท์มือถือที่ป้อนไม่ตรงกับประเทศที่เลือก',
    'IDC-02-00226': 'รหัสประเทศถูกแบน',
    'IDC-02-00029': 'รหัสยืนยันไม่ถูกต้องหรือหมดอายุแล้ว',
    'IDC-02-0013': 'การเข้าสู่ระบบ SMS ล้มเหลว รหัสยืนยันผิดพลาด',
    'IDC-02-0020': 'การยืนยันล้มเหลว รหัสการยืนยันไม่ถูกต้อง',
    'IDC-02-00028': 'หมายเลขโทรศัพท์ต้องเป็นตัวเลขที่มีความยาว 6 ถึง 30',
    'IDC-02-00012': 'หมายเลขโทรศัพท์มือถือไม่ถูกต้อง',

    // 错误操作锁定
    accountLock: 'หมายเลขโทรศัพท์มือถือหรือรหัสการยืนยันไม่ถูกต้อง สามารถลองได้อีก {number} ครั้ง',
    accountLocked: 'ลองแล้วล้มเหลวหลายครั้งเกินไป โปรดลองอีกครั้งในอีก {number} วินาที',
    operationRisk: 'ปฏิบัติการปัจจุบันมีความเสี่ยงด้านความปลอดภัย โปรดลองอีกครั้งใน {number} วินาที',

    // 频繁操作
    'IDC-02-00038': 'โปรดลองอีกครั้งในอีก 60 วินาที',
    'IDC-02-00064': 'คุณได้ส่งรหัสยืนยันทาง SMS บ่อยเกินไป โปรดลองอีกครั้งในอีก 24 ชั่วโมงต่อมา',
    'IDC-02-00211': 'การดําเนินการในปัจจุบันมีความเสี่ยงด้านความปลอดภัย โปรดลองอีกครั้งในภายหลัง',
    'IDC-02-00212':
      'จํานวนรหัสยืนยันทาง SMS ที่ส่งโดยหมายเลขโทรศัพท์มือถือของคุณบ่อยเกินไป โปรดเปลี่ยนหมายเลขโทรศัพท์มือถือของคุณหรือลองอีกครั้งในอีก 24 ชั่วโมงต่อมา',
    'IDC-02-00213': 'คุณได้ส่งรหัสยืนยันทาง SMS บ่อยเกินไป โปรดลองอีกครั้งในอีก 24 ชั่วโมงต่อมา',
    'IDC-02-00215':
      'จํานวนรหัสยืนยันทาง SMS ที่ส่งโดยหมายเลขโทรศัพท์มือถือของคุณบ่อยเกินไป โปรดลองเปลี่ยนหมายเลขโทรศัพท์มือถือหรือเลือกวิธีการยืนยันตัวตนอื่น หรือลองอีกครั้งในอีก 24 ชั่วโมงต่อมา',
    'IDC-02-00228': 'คุณส่งรหัสยืนยัน SMS บ่อยเกินไป โปรดลองอีกครั้งในอีก 1 ชั่วโมง!',
    'IDC-02-00092': 'การดําเนินการปัจจุบันบ่อยเกินไป โปรดลองอีกครั้งในอีก 24 ชั่วโมงหลังจากนี้',

    // 请求异常
    'IDC-10-00400': 'ข้อยกเว้นสําหรับคําขอของลูกค้า',
    'IDC-10-00500': 'ข้อผิดพลาดภายในระบบ ',
    'IDC-02-00264': 'คําขอการเข้าถึงที่ไม่ได้รับอนุญาตเป็นสิ่งต้องห้าม',
    'IDC-02-00063': 'พารามิเตอร์ไม่ถูกต้อง',
    'IDC-03-0007':
      'การดําเนินการปัจจุบันมีความเสี่ยงด้านความปลอดภัยและไม่สามารถลงทะเบียนได้ในขณะนี้', // 机翻
    'IDC-03-00057': 'การดําเนินการในปัจจุบันมีความเสี่ยงด้านความปลอดภัย',

    // 页面过期
    'IDC-00-00017': 'หน้านี้หมดอายุแล้ว',
  },

  // 注册协议、隐私声明对话框
  backButton: 'ย้อนกลับ',
  closeButton: 'ปิด',

  // 滑块验证相关：
  resourceReqFailed: 'คําขอทรัพยากรล้มเหลว รีเฟรชหน้าแล้วลองอีกครั้ง',
  verifyFailedAndPlsRetry: 'การตรวจสอบสิทธิ์ล้มเหลว โปรดลองอีกครั้ง',
  serviceErrAndPlsRetry: 'ข้อยกเว้นของบริการ โปรดลองอีกครั้ง',
  learnMore: 'เรียนรู้เพิ่มเติม',
  cookieBannerText: 'เว็บไซต์นี้ใช้ฟังก์ชันคุกกี้เพื่อมอบประสบการณ์การใช้งานที่ดีที่สุดแก่คุณ',
};
